import React from 'react';
import { useLang, T } from '../lib/lang';

const NAV = [
  { id: 'timeline', label: { ru: 'timeline', en: 'timeline' } },
  { id: 'video', label: { ru: 'video', en: 'video' } },
  { id: 'metaphors', label: { ru: 'metaphors', en: 'metaphors' } },
  { id: 'notes', label: { ru: 'bonus', en: 'bonus' } },
  { id: 'prompt', label: { ru: 'prompt', en: 'prompt' } },
  { id: 'transcript', label: { ru: 'transcript', en: 'transcript' } },
];

export function Header() {
  const { lang, setLang } = useLang();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-border bg-bg/80 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <a href="#top" className="flex items-center gap-3">
          <img src="/assets/logo_rb.png" alt="AI Mindset" className="h-6 w-auto opacity-90" />
          <div className="leading-tight">
            <div className="text-[12px] font-medium tracking-wide text-text">ifs + ai</div>
            <div className="text-[11px] text-dim">ivanov × ai mindset</div>
          </div>
        </a>

        <nav className="hidden items-center gap-6 lg:flex">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="text-[11px] uppercase tracking-widest text-muted transition-colors hover:text-text"
            >
              <T ru={item.label.ru} en={item.label.en} />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setLang('en')}
            className={[
              'rounded border px-3 py-1 text-[10px] tracking-widest transition-colors',
              lang === 'en' ? 'border-text bg-border text-text' : 'border-border text-dim hover:text-muted',
            ].join(' ')}
          >
            EN
          </button>
          <button
            type="button"
            onClick={() => setLang('ru')}
            className={[
              'rounded border px-3 py-1 text-[10px] tracking-widest transition-colors',
              lang === 'ru' ? 'border-text bg-border text-text' : 'border-border text-dim hover:text-muted',
            ].join(' ')}
          >
            RU
          </button>
        </div>
      </div>
    </header>
  );
}
